import { atom } from 'jotai';

import { cameraDetailQueryAtom } from '../_graphql/queryCameraDetail';

import { settingsRouteParamAtom } from './settingsModule.state';

export const $cameraId = settingsRouteParamAtom(
  ['/hardware/cameras/:id'],
  'id',
);

export const $remoteCameraDetail = cameraDetailQueryAtom((get) => {
  const cameraId = get($cameraId);
  return {
    variables: {
      ids: cameraId ? [cameraId] : [],
    },
    skip: !cameraId,
  };
});

export const $isCameraLoading = atom((get) => {
  const data = get($remoteCameraDetail);
  return data?.isLoading ?? false;
});

export const $cameraError = atom((get) => {
  const data = get($remoteCameraDetail);
  return data?.error ?? null;
});
